<template>
  <div>
    <div style="margin-bottom: 20px">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item> 调研任务 </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <el-card shadow="hover" style="margin-bottom: 12px; padding: 10px">
      <el-form :inline="true" :model="formInline" @submit.native.prevent>
        <el-form-item label="中心仓">
          <customer-storehouse-select
            :defaultFirst="true"
            style="width: 240px"
            v-model="storehouseGuid"
            placeholder="门店"
          />
        </el-form-item>
        <div>
          <el-button :size="$xUISize" @click="createClick" type="primary">
            创建调研单
          </el-button>
        </div>
      </el-form>
    </el-card>
    <el-card shadow="hover">
      <div style="padding: 10px" v-if="!!storehouseGuid">
        <template v-if="!refresAble">
          <arranged-survey-list :query="defaultParams" />
        </template>
      </div>
      <el-empty v-else description="请选择中心仓库" :image-size="100" />
    </el-card>
  </div>
</template>

<script>
import surveyCreatePage from "./__arranged_survey_create.vue";
import customerStorehouseSelect from "../../../../components/business/customerStorehouseSelect.vue";
import arrangedSurveyList from "./__arranged_survey_list.vue";

export default {
  components: {
    customerStorehouseSelect,
    arrangedSurveyList,
  },
  props: {
    tabName: {
      type: String,
    },
    tabProps: {
      type: Object,
      default: () => ({}),
    },
    params: {
      type: Object,
      default: () => ({}),
    },
    query: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    defaultParams() {
      return Object.assign(
        {
          storehouseGuid: this.storehouseGuid,
        },
        this.queryModel
      );
    },
    pageParams() {
      return Object.assign({}, (this.$route && this.$route.params) || {}, this.params);
    },
    pageQuery() {
      return Object.assign({}, (this.$route && this.$route.query) || {}, this.query);
    },
  },
  methods: {
    refresh() {
      this.refresAble = true;
      this.$nextTick(() => {
        this.refresAble = false;
      });
    },
    onActiveClick(mode) {
      this.activeName = mode;
    },
    createClick() {
      this.$drawer.openDrawer({
        title: "创建调研单",
        refresh: this.refresh,
        component: surveyCreatePage,
        params: this.defaultParams,
      });
    },
    clearClick() {
      this.formInline = {
        optStatus: "",
        queryValue: "",
      };
      this.queryModel = {
        optStatus: "",
        queryValue: "",
      };
    },
    queryClick() {
      this.queryModel = Object.assign({}, this.formInline);
    },
  },
  watch: {
    storehouseGuid() {
      this.commitState({ curStorehouseGuid: this.storehouseGuid });
    },
  },
  data() {
    return {
      refresAble: false,
      storehouseGuid: "",
      activeName: "arranged",
      queryModel: {
        optStatus: "",
        queryValue: "",
      },
      formInline: {
        optStatus: "",
        queryValue: "",
      },
    };
  },
  mounted() {
    this.storehouseGuid = this.readState("curStorehouseGuid", "");
  },
};
</script>
